module.exports = __webpack_public_path__ + "images/404.1792381924319.png";